export const clockStyles = {
  spacing: {
    flexBasis: '50%',
    justifyContent: 'space-around',
    marginTop: '30px',
    marginBottom: '30px',
    '@media (max-width:599px)': {
      marginLeft: '25%'
    },
    '@media (max-width:460px)': {
      marginLeft: '20%'
    }
  }
};
